import React, { useState, useEffect } from 'react';

import officePNG from 'connect/search/office_grayscale.png';
import retailPNG from 'connect/search/retail_grayscale.png';
import industrialPNG from 'connect/search/industrial_grayscale.png';
import landPNG from 'connect/search/land_grayscale.png';
import multiFamilyPNG from 'connect/search/multifamily_grayscale.png';
import specialPurposePNG from 'connect/search/special_purpose_grayscale.png';
import hospitalityPNG from 'connect/search/hospitality_grayscale.png';
import residentialPNG from 'connect/search/residential_grayscale.png';
import type { CallListable, InsightsProperty } from 'bundles/connect/types';
import { Badge } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLightbulbOn } from '@fortawesome/pro-regular-svg-icons';
import {
  selectSavedSearchCreatedAt,
  selectSavedSearchInsightsPropertyIds
} from 'bundles/connect/components/store/selectors/saved_search';
import { useSelector } from 'react-redux';

const THUMBNAILS = {
  1: officePNG,
  2: retailPNG,
  3: industrialPNG,
  5: landPNG,
  6: multiFamilyPNG,
  7: specialPurposePNG,
  8: hospitalityPNG,
  10: residentialPNG,
};

type Props = {
  result: InsightsProperty | CallListable;
}

export default function OffMarketPropertyImage({ result }: Props) {
  const [fallback, setFallback] = useState(false);
  const savedSearchCreatedAt = useSelector(selectSavedSearchCreatedAt);
  const savedSearchInsightsPropertyIds = useSelector(selectSavedSearchInsightsPropertyIds);

  useEffect(() => {
    // Reset fallback when result changes
    if (!result.streetviewUrl) {
      setFallback(true);
    } else {
      setFallback(false);
    }
  }, [result.streetviewUrl]);

  const placeholderImg = THUMBNAILS[result.propertyTypeId] || THUMBNAILS[8];
  const imageSrc = fallback ? placeholderImg : result.streetviewUrl;

  const getBadgeText = () => {
    if (savedSearchCreatedAt && savedSearchInsightsPropertyIds) {
      const createdAtDateDay = new Date(savedSearchCreatedAt);
      createdAtDateDay.setHours(0, 0, 0, 0);
      const savedSearchInsightsProperty = savedSearchInsightsPropertyIds[result.propertyId];
      if (savedSearchInsightsProperty) {
        const addedAtDateDay = new Date(savedSearchInsightsProperty.addedAt);
        addedAtDateDay.setHours(0, 0, 0, 0);
        const thirtyDaysAgo = new Date();
        thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
        if (addedAtDateDay > createdAtDateDay && addedAtDateDay > thirtyDaysAgo) {
          return 'New';
        }
      }
    }

    return null;
  };
  const badgeText = getBadgeText();

  return (
    <div className="position-relative d-flex align-items-center justify-content-center w-100 h-100">
      {badgeText && (
        <Badge
          bg=""
          className="position-absolute top-0 start-0 m-1 px-1 py-0-5 fs-x-small badge-muted badge-secondary"
          style={{ zIndex: 1 }}
        >
          <FontAwesomeIcon className="text-primary" icon={faLightbulbOn} />
          {badgeText}
        </Badge>
      )}
      <img
        className="d-md-none placeholder-thumb object-fit-contain w-100 h-100 rounded"
        src={imageSrc}
        onError={() => setFallback(true)}
      />
      <img
        className="d-none d-md-block placeholder-thumb w-100 h-100 rounded"
        src={imageSrc}
        onError={() => setFallback(true)}
      />
    </div>
  );
}
